import './DocumentUploadModal.scss';
import React, { useEffect } from 'react';
import { formatText } from 'core/i18n';
import { recordEventCustomOnly } from 'utilities/uTagging';
import { ModalComponent } from 'components/modal/modalComponent';
import { buildModalContentbyType } from './utils/buildModalContentbyType';
import { DOCUMENT_TYPES } from 'constants/documents';
import { PATH_DOCUMENTATION } from 'constants/uTagConstants/paths';
import { VALID_DOCUMENT_TYPES_FOR_ACCEPTED_DOCUMENTS_CONTENT } from '../../constants';

const VALID_MODAL_TYPES = [
    DOCUMENT_TYPES.DNI_FRONT,
    DOCUMENT_TYPES.DNI_BACK,
    DOCUMENT_TYPES.NIE_FRONT,
    DOCUMENT_TYPES.PASSPORT_FRONT,
    DOCUMENT_TYPES.PASSPORT_BACK,
    DOCUMENT_TYPES.PERMIT_FRONT,
    DOCUMENT_TYPES.PERMIT_BACK,
    DOCUMENT_TYPES.DAAL,
    DOCUMENT_TYPES.RECIBO_TRANSFERENCIA,
];

const doTagging = (accionEvento, etiquetaEvento) => {
    recordEventCustomOnly({
        categoriaEvento: PATH_DOCUMENTATION,
        accionEvento,
        etiquetaEvento,
    });
};
const taggingActions = {
    [DOCUMENT_TYPES.DNI_FRONT]: value => doTagging(`modal/subir documento/doble-check/DNI/front`, value),
    [DOCUMENT_TYPES.DNI_BACK]: value => doTagging(`modal/subir documento/doble-check/DNI/back`, value),
    [DOCUMENT_TYPES.NIE_FRONT]: value => doTagging(`modal/subir documento/doble-check/CUE/front`, value),
    [DOCUMENT_TYPES.PASSPORT_FRONT]: value => doTagging(`modal/subir documento/doble-check/pasaporte/front`, value),
    [DOCUMENT_TYPES.DAAL]: value => doTagging(`modal/subir documento/doble-check/ingresos`, value),
    [DOCUMENT_TYPES.RECIBO_TRANSFERENCIA]: value => doTagging(`modal/subir documento/doble-check/domicilio`, value),
};

export const DocumentUploadModal = ({ documentType, accountType, onClose, modalIsOpen, onConfirm, profession }) => {
    useEffect(() => {
        modalIsOpen && taggingActions[documentType]?.('vista');
    }, [modalIsOpen]);

    const modalContent = buildModalContentbyType(documentType, accountType, profession);
    const isValidDocumentType = VALID_DOCUMENT_TYPES_FOR_ACCEPTED_DOCUMENTS_CONTENT.includes(documentType);
    const buttonConfirmText = isValidDocumentType ? 'button-understood' : 'uploads-attachDocumentConfirm';

    const handleClose = () => {
        taggingActions[documentType]?.('salir');
        onClose();
    };

    const handleConfirm = () => {
        taggingActions[documentType]?.('continuar');
        onConfirm();
    };

    if (!VALID_MODAL_TYPES.includes(documentType)) {
        return null;
    }

    return (
        <ModalComponent
            isOpen={modalIsOpen}
            confirmText={formatText(buttonConfirmText)}
            onCancel={handleClose}
            onConfirm={handleConfirm}
            title={formatText('uploads-avoidRejectedDocument')}
            className="document-upload-modal"
        >
            <div className="modal-content-wrapper">{modalContent}</div>
        </ModalComponent>
    );
};
